import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import NoData from "../components/NoData";
import Product2 from "../components/Product2";
import { BsFillHeartFill } from "react-icons/bs";

import {alert, confirm} from "../components/MegConfirmAlert";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';



export default function Pick() {
    const { t } = useTranslation();

    const [data, setData] = useState({});
    const [request] = useAxios();
    const fetchData = async () => {
            
        const response = await request.post("/app/wishlist/getMyWishListAPI", {
                
        });

        if(response.data.resultCode === 200){
            setData(response.data.result);          
            console.log(response.data.result);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="search" pageTitle={t(`Message.common_bottom_navigation_bar_wishlist`)}/>

            {/* 관심상품 없을때 로그인 안해도 보이는 페이지 입니당!!! */}
            <div className="pickArea">
                {data.resultList && data.resultList.length === 0?(
                <div className="pickNodata">
                    
                        <>
                    <NoData text={t(`Message.wishlist_screen_empty_wishlist_msg`)}/>
                    <p className="cDisa dfccG4 pt8">{t(`Message.wishlist_screen_wish_cn_msg1`)} <span className="btn2424 pickBtn"><BsFillHeartFill /></span>{t(`Message.wishlist_screen_wish_cn_msg2`)}</p>
                        </>
                    
                </div>
                ):(
                <div className="howAbout">
                    {data.resultList && data.resultList.map((obj, index) => (                
                    <Product2 type="type5" key={index}
                    prodName={obj.goodsNm}
                    cost={"￦"+obj.nrmltAmount.toLocaleString('ko-KR')}                    
                    disprice={"￦"+obj.sleAmount.toLocaleString('ko-KR')}
                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                    obj = {obj}
                    setPickData = {fetchData}
                    />
                    ))}                 
                </div>
                )}
            </div>









            {/* 관심상품 있을때 (로그인해야하는 페이지임니다!!!!) */}
{/* 
            <div className="pickWr">
                <div className="txtWr">
                    <p>관심상품은 최대 999개까지 저장됩니다.</p>
                    <p>관심상품으로 등록한 상품은 4개 입니다.</p>
                </div>

                <div className="pickList">
                    <Product2 
                        img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=839"
                        type="type5"
                        prodName="국내산 닭고기 닭 한마리"
                        disprice="8,900원" 
                        percent="29%"
                        cost="6,300원"
                    />
                    <Product2 
                        img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=839"
                        type="type5"
                        prodName="국내산 닭고기 닭 한마리"
                        disprice="8,900원" 
                        percent="29%"
                        cost="6,300원"
                    />
                    <Product2 
                        img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=839"
                        type="type5"
                        prodName="국내산 닭고기 닭 한마리"
                        disprice="8,900원" 
                        percent="29%"
                        cost="6,300원"
                    />
                    <Product2 
                        img="https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn=839"
                        type="type5"
                        prodName="국내산 닭고기 닭 한마리"
                        disprice="8,900원" 
                        percent="29%"
                        cost="6,300원"
                    />
                </div>
            </div> 
*/}


        </div>
    )
}